import {observable} from 'mobx';

const ServerStore = observable({
  account: null,
  BASE_URL: null,
  tokenJson: null,
});

export {ServerStore};
